module.exports = __webpack_public_path__ + "img/polygon-layer.d8f6545e.svg";